import { createFileRoute } from "@tanstack/react-router";

import { NutrologoBauru } from "@/components/itv/pages/NutrologoBauru";
import { lerPaginaLocal } from "@/lib/pagina-local";
import { carregarPaginaSimples } from "@/lib/pagina-simples";
import bruto from "@/content/locais/nutrologo-em-bauru.md?raw";

const dados = lerPaginaLocal(bruto);

export const Route = createFileRoute("/nutrologo-em-bauru")({
  loader: () => carregarPaginaSimples(dados.url, dados.title, dados.description),
  // O JSON-LD aprovado já traz o médico e o consultório completos.
  staticData: { declaraPhysician: true, declaraClinica: true },
  head: ({ loaderData }) => ({
    meta: loaderData?.meta ?? [],
    links: loaderData?.links ?? [],
  }),
  component: Page,
});

function Page() {
  return (
    <>
      <NutrologoBauru />
      {/* JSON-LD aprovado, sem alteração. */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: dados.schema.replace(/</g, "\\u003c") }}
        suppressHydrationWarning
      />
    </>
  );
}
